import { StandardEvents } from '@shopify/events';

(() => {
  if (window.takooFoundationChatGuard || !document.querySelector('[data-takoo-foundation]')) return;
  window.takooFoundationChatGuard = true;
  const section = document.querySelector('[data-takoo-foundation]').closest('.shopify-section');
  let quantityGeneration = 0;
  // The native form updates constraints but leaves the initial disabled flag
  // behind. Mirror the new server-rendered flag without changing quantity rules.
  section?.addEventListener(StandardEvents.productSelect, async event => {
    if (!event.promise) return;
    const generation = ++quantityGeneration;
    try {
      const { detail } = await event.promise;
      if (generation !== quantityGeneration || !detail?.html) return;
      const serverInput = detail.html.querySelector('product-form-component quantity-selector-component input[ref="quantityInput"]');
      const currentInput = section.querySelector('product-form-component quantity-selector-component input[ref="quantityInput"]');
      if (serverInput && currentInput) currentInput.disabled = serverInput.disabled;
    } catch {
      // The native variant picker owns request errors and aborted selections.
    }
  });
  let queued = false;
  const observedChatRoots = new WeakSet();
  const overlaps = (a, b) => a.left < b.right + 8 && a.right > b.left - 8 && a.top < b.bottom + 8 && a.bottom > b.top - 8;
  const check = () => {
    queued = false;
    const chatRoot = document.querySelector('shopify-chat')?.shadowRoot;
    const runtimeRoot = chatRoot?.querySelector('shopify-agent-runtime')?.shadowRoot;
    // Shopify can move the launcher into its runtime after the shell loads.
    for (const root of [chatRoot, runtimeRoot]) {
      if (root && !observedChatRoots.has(root)) {
        new MutationObserver(schedule).observe(root, {childList: true, subtree: true});
        observedChatRoots.add(root);
      }
    }
    const launcher = chatRoot?.querySelector('[part="activator"]') || runtimeRoot?.querySelector('[part="activator"]');
    const rect = launcher?.getBoundingClientRect();
    const controls = document.querySelectorAll('main form[action*="/cart/add"] button[type="submit"], main .variant-option__button-label, main shopify-accelerated-checkout, main .sticky-add-to-cart__button');
    const blocked = !!rect && rect.width > 0 && Array.from(controls).some(control => {
      const r = control.getBoundingClientRect();
      const style = getComputedStyle(control);
      return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight && style.visibility !== 'hidden' && style.display !== 'none' && overlaps(rect, r);
    });
    document.documentElement.classList.toggle('takoo-purchase-chat-overlap', blocked);
  };
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(check); } };
  addEventListener('scroll', schedule, {passive: true});
  addEventListener('resize', schedule, {passive: true});
  addEventListener('load', schedule, {once: true});
  document.addEventListener('change', schedule);
  document.addEventListener('click', schedule);
  document.addEventListener('transitionend', schedule);
  new MutationObserver(schedule).observe(document.querySelector('main') || document.body, {childList: true, subtree: true});
  customElements.whenDefined('shopify-chat').then(() => { schedule(); setTimeout(schedule, 500); });
  schedule();
})();
